import DesignSystemButton from './DesignSystemButton';
import React from 'react';
import Show from '../Show/Show';
import { DesignSystemSecondaryButton } from './DesignSystemSecondaryButton';
import { NEUTRAL_TEXT0 } from '../../config/designSystem/Colors';
import { SPACING } from '../../config/designSystem/Spacing';
import { View } from 'react-native';

export const DEFAULT_SECOND_BUTTON_COLOR = NEUTRAL_TEXT0;

interface TwoButtonsProps {
    onPressTop: () => void;
    onPressBelow: () => void;
    labelTop: string
    labelBelow: string;
    disallowTop?: boolean;
    disallowBelow?: boolean;

}

export const DesignSystemTwoButtonsVertical = ({ onPressTop, onPressBelow,labelTop, labelBelow,disallowTop,disallowBelow}: TwoButtonsProps) => {

  if(disallowTop && disallowBelow){
    return(<></>);
  }

  return (
    <View style={{rowGap: SPACING['sp-16']}}>
      <Show when={!disallowTop}>
        <DesignSystemButton label={labelTop}
          onPress={onPressTop}

        />
      </Show>
      <Show when={!disallowBelow}>
        <DesignSystemSecondaryButton label={labelBelow}
          onPress={onPressBelow}

        />
      </Show>

    </View>);
};